import { defineStore } from "pinia";
import Services from '@/services/PolicieServices'

export const usePoliceStore = defineStore("police", {
persist: true,
state:()=>({
    policie: {},
    policies: [],
}),
getters : {
    getPolicie() {
        return this.policie
    },
    getPolicies() {
        return this.policies
    },
},
actions : {
    /** Start Sets */
    setPolicie(policie) {
        this.policie = policie;
    },
    setPolicies(policies) {
        this.policies = policies;
    },
    /** End Sets */

    /** Start Actions */
    getRulesByTableNamefromCache(tbName, personTypeName) {        
        return (this.policies.find((x) => x.tableName === tbName)?.fields ?? []).map((x)=>{
            return {
                [x.fieldName]: Boolean(x[personTypeName]),
            }
        }).reduce((acc, item) => ({ ...acc, ...item }), {})
    },
    getByTableName(tableName){
        return Services.getAll(tableName)
        .then((response)=>{
            this.policies.push(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setPolicies(response.data.data)
            return response
        })
    },
    edit(tbName, data) {
        return Services.edit(tbName, data)
    },
    /** End Actions */
}
});
